import API_URL from '../config';
import axios from 'axios';

import { getCookie } from './../utils/cookies';

export const getAllProductsEssayApi = async(Name, Code, Categorie) => {
    try {
        const token = getCookie("T6hVzR7c0g3maM3F")
        const iv = getCookie("02hfCmUqpk66w4uG")
        const id = getCookie("3F2Mb2pJ1YRro5Z4")

        const option = {
            headers: {
                Authorization: `Bearer ${token}`
            }
        }

        const res = await axios.get(`${API_URL}/api/V2/productsEssay/getAllProducts/${id}/${iv}?Name=${Name}&Code=${Code}&Categorie=${Categorie}`, option);
        return res.data
    }
    catch (err) {
        throw err
    }
}

export const getAllProductsEssayEscompteApi = async() => {
    try {
        const token = getCookie("T6hVzR7c0g3maM3F")
        const iv = getCookie("02hfCmUqpk66w4uG")
        const id = getCookie("3F2Mb2pJ1YRro5Z4")

        const option = {
            headers: {
                Authorization: `Bearer ${token}`
            }
        }

        const res = await axios.get(`${API_URL}/api/V2/productsEssay/getAllProductsEscompt/${id}/${iv}`, option);
        return res.data
    }
    catch (err) {
        throw err
    }
}

export const getAllProductsEssayBonusApi = async() => {
    try {
        const token = getCookie("T6hVzR7c0g3maM3F")
        const iv = getCookie("02hfCmUqpk66w4uG")
        const id = getCookie("3F2Mb2pJ1YRro5Z4")

        const option = {
            headers: {
                Authorization: `Bearer ${token}`
            }
        }

        const res = await axios.get(`${API_URL}/api/V2/productsEssay/getAllProductsBonus/${id}/${iv}`, option);
        return res.data
    }
    catch (err) {
        throw err
    }
}

export const addNewProductEssayApi = async (productObject) => {
    try {
        const token = getCookie("T6hVzR7c0g3maM3F")
        const iv = getCookie("02hfCmUqpk66w4uG")
        const id = getCookie("3F2Mb2pJ1YRro5Z4")

        const option = {
            headers: {
                Authorization: `Bearer ${token}`
            }
        }

        const res = await axios.post(`${API_URL}/api/V2/productsEssay/addProduct/${id}/${iv}`, productObject, option);
        return res.data
    }
    catch (err) {
        throw err
    }
}

export const getOneProductEssayApi = async (productID) => {
    try {
        const token = getCookie("T6hVzR7c0g3maM3F")
        const iv = getCookie("02hfCmUqpk66w4uG")
        const id = getCookie("3F2Mb2pJ1YRro5Z4")

        const option = {
            headers: {
                Authorization: `Bearer ${token}`
            }
        }

        const res = await axios.get(`${API_URL}/api/V2/productsEssay/getOneProduct/${id}/${iv}/${productID}`, option);
        return res.data
    }
    catch (err) {
        throw err
    }
}

export const updateProductEssayApi = async (productObject, productID) => {
    try {
        const token = getCookie("T6hVzR7c0g3maM3F")
        const iv = getCookie("02hfCmUqpk66w4uG")
        const id = getCookie("3F2Mb2pJ1YRro5Z4")

        const option = {
            headers: {
                Authorization: `Bearer ${token}`
            }
        }

        const res = await axios.put(`${API_URL}/api/V2/productsEssay/updateProduct/${id}/${iv}/${productID}`, productObject, option);
        return res.data
    }
    catch (err) {
        throw err
    }
}

export const updateProductEssayStatusApi = async (productID, productCategoryID) => {
    try {
        const token = getCookie("T6hVzR7c0g3maM3F")
        const iv = getCookie("02hfCmUqpk66w4uG")
        const id = getCookie("3F2Mb2pJ1YRro5Z4")

        const option = {
            headers: {
                Authorization: `Bearer ${token}`
            }
        }

        const res = await axios.put(`${API_URL}/api/V2/productsEssay/updateProductStatus/${id}/${iv}/${productID}/${productCategoryID}`, {}, option);
        return res.data
    }
    catch (err) {
        throw err
    }
}

export const updateProductEssayLotNumberApi = async (productID, productCategoryID, lotNumber) => {
    try {
        const token = getCookie("T6hVzR7c0g3maM3F")
        const iv = getCookie("02hfCmUqpk66w4uG")
        const id = getCookie("3F2Mb2pJ1YRro5Z4")

        const option = {
            headers: {
                Authorization: `Bearer ${token}`
            }
        }

        const objectData = {
            LotNumber: lotNumber
        }

        const res = await axios.put(`${API_URL}/api/V2/productsEssay/updateProductLotNumber/${id}/${iv}/${productID}/${productCategoryID}`, objectData, option);
        return res.data
    }
    catch (err) {
        throw err
    }
}

export const deleteOneProductEssayApi = async (productID, categoryID) => {
    try {
        const token = getCookie("T6hVzR7c0g3maM3F")
        const iv = getCookie("02hfCmUqpk66w4uG")
        const id = getCookie("3F2Mb2pJ1YRro5Z4")

        const option = {
            headers: {
                Authorization: `Bearer ${token}`
            }
        }

        const res = await axios.delete(`${API_URL}/api/V2/productsEssay/deleteOneProduct/${id}/${iv}/${productID}/${categoryID}`, option);
        return res.data
    }
    catch (err) {
        throw err
    }
}

export const archiveProductEssayApi = async (productID) => {
    try {
        const token = getCookie("T6hVzR7c0g3maM3F")
        const iv = getCookie("02hfCmUqpk66w4uG")
        const id = getCookie("3F2Mb2pJ1YRro5Z4")

        const option = { headers: { Authorization: `Bearer ${token}` } }

        const res = await axios.put(`${API_URL}/api/V2/productsEssay/archiveProduct/${id}/${iv}/${productID}`, {}, option);
        return res.data
    }
    catch (err) {
        throw err
    }
}

export const getArchivedProductsEssayApi = async () => {
    try {
        const token = getCookie("T6hVzR7c0g3maM3F")
        const iv = getCookie("02hfCmUqpk66w4uG")
        const id = getCookie("3F2Mb2pJ1YRro5Z4")

        const option = { headers: { Authorization: `Bearer ${token}` } }

        const res = await axios.get(`${API_URL}/api/V2/productsEssay/getArchivedProducts/${id}/${iv}`, option);
        return res.data
    }
    catch (err) {
        throw err
    }
}

export const productEssayInvetaireListApi = async (filtredObject) => {
    try {
        const token = getCookie("T6hVzR7c0g3maM3F")
        const iv = getCookie("02hfCmUqpk66w4uG")
        const id = getCookie("3F2Mb2pJ1YRro5Z4")

        const option = {
            headers: {
                Authorization: `Bearer ${token}`
            }
        }

        const res = await axios.get(`${API_URL}/api/V2/productsEssay/productInvetaireList/${id}/${iv}?Product=${filtredObject.Product}&category=${filtredObject.Categorie}&Depot=${filtredObject.Depot}`, option);
        return res.data
    }
    catch (err) {
        throw err
    }
}

export const getAllNonCounterDepotsEssay = async () => {
    try {
        const token = getCookie("T6hVzR7c0g3maM3F")
        const iv = getCookie("02hfCmUqpk66w4uG")
        const id = getCookie("3F2Mb2pJ1YRro5Z4")

        const option = {
            headers: {
                Authorization: `Bearer ${token}`
            }
        }

        const res = await axios.get(`${API_URL}/api/V2/productsEssay/getAllNonCounterDepots/${id}/${iv}`, option);
        return res.data
    }
    catch (err) {
        throw err
    }
}

export const getAllProductsDataByCategoryEssayApi = async (CategoryID) => {
    try {
        const token = getCookie("T6hVzR7c0g3maM3F")
        const iv = getCookie("02hfCmUqpk66w4uG")
        const id = getCookie("3F2Mb2pJ1YRro5Z4")

        const option = {
            headers: {
                Authorization: `Bearer ${token}`
            }
        }

        const res = await axios.get(`${API_URL}/api/V2/productsEssay/getProductsByCategory/${id}/${iv}/${CategoryID}`, option);
        return res.data
    }
    catch (err) {
        throw err
    }
}

export const updateSingleDepotStockEssayApi = async (Code, City, Disponible, fromDepot, LotNumber) => {
    try {
        const token = getCookie("T6hVzR7c0g3maM3F")
        const iv = getCookie("02hfCmUqpk66w4uG")
        const id = getCookie("3F2Mb2pJ1YRro5Z4")

        const option = {
            headers: {
                Authorization: `Bearer ${token}`
            }
        }

        const requestData = {
            Code,
            Disponible
        }

        if (City) {
            requestData.City = City
        }

        if (fromDepot) {
            requestData.fromDepot = fromDepot
        }

        if (LotNumber) {
            requestData.LotNumber = LotNumber
        }

        const res = await axios.put(`${API_URL}/api/V2/productsEssay/updateSingleDepotStock/${id}/${iv}`, requestData, option);
        return res.data
    }
    catch (err) {
        throw err
    }
}
